import { Grid, Typography } from '@mui/material';
import { useParams } from 'react-router';
import AppContainer from 'src/components/appComponents/AppContainer';
import { paths } from 'src/routes/paths';
import PublishChannelAiSuggestionForm from 'src/sections/channelAiSuggestions/PublishChannelAiSuggestionForm';

export default function PublishChannelAiSuggestionPage() {
  const { suggestedVideoId } = useParams();

  return (
    <AppContainer
      pageTitle="Publish"
      routeLinks={[
        { name: 'ChannelAi Suggestions' },
        {
          name: 'Suggestions',
          href: `${paths.dashboard.channelAiSuggestions.suggestions}`,
        },
        {
          name: 'View',
          href: `${paths.dashboard.channelAiSuggestions.suggestionDetails(suggestedVideoId ?? '')}`,
        },
        {
          name: 'Publish',
        },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} mb={4}>
          <Typography variant="h4" color="primary">
            Video Suggestion Info
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <PublishChannelAiSuggestionForm />
        </Grid>
      </Grid>
    </AppContainer>
  );
}
